document.addEventListener('DOMContentLoaded', function() {
  // AOSが定義されているかチェック
  if (typeof AOS !== 'undefined') {
    // AOSの初期化を最初に実行
    AOS.init();

    // g-sliderの初期化
    if ($('.g-slider').length) {
      $('.g-slider').not('.slick-initialized').slick({
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: 'linear',
        slidesToShow: 7,
        swipe: false,
        arrows: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 4,
            },
          },
        ],
      });
    }

    // スライダーの初期化後に再度AOSを更新
    // これにより、スライダーによって追加された要素にもアニメーションが適用される
    setTimeout(function() {
      AOS.refresh();
    }, 500);
  } else {
    console.warn('AOSライブラリが読み込まれていません。アニメーション機能は無効化されています。');
  }
});
